export const enum FlowType {
  FM = 'fm',
  MNVV = 'mnvv',
  CELEBRATION = 'celebration',
}
